import { View, Text, Link } from "@react-pdf/renderer";
import { styles } from "../MemberDetailsStyle";

export function SecondRow({ item,translate }) {
  return (
    <View style={styles.secondRow.self}>
      <View style={styles.secondRow.left.self}>
        <View>
          <Text style={styles.secondRow.left.address}>{translate('directory.member.info.label.address')}</Text>
          {item.full_str.split(";").map((addLine, i) => {
            return (
              <Text key={i} style={styles.secondRow.left.addLine}>
                {addLine}
              </Text>
            );
          })}
        </View>
        {item.phone?.length > 0 && (
          <View style={styles.secondRow.left.contact}>
            <Link style={styles.link} src={`tel:${item.phone}`}>
              {item.phone}
            </Link>
          </View>
        )}
        {item.email?.length > 0 && (
          <View style={styles.secondRow.left.contact}>
            <Link style={styles.link} src={`mailto:${item.email}`}>
              {item.email}
            </Link>
          </View>
        )}
        {item.xing_profile?.length > 0 && (
          <View style={styles.secondRow.left.contact}>
            <Link style={styles.link} src={item.xing_profile}>
              {item.xing_profile}
            </Link>
          </View>
        )}

        {item.linkedin_profile?.length > 0 && (
          <View style={styles.secondRow.left.contact}>
            <Link style={styles.link} src={item.linkedin_profile}>
              {item.linkedin_profile}
            </Link>
          </View>
        )}
      </View>
      <View style={styles.secondRow.right.self}>
        {item.work_specialisations.some((e) => e.id) > 0 && (
          <View style={styles.secondRow.right.block}>
            <Text style={styles.secondRow.right.block_title}>{translate("directory.member.info.expert.label.specialisations")}</Text>
            {item.work_specialisations.map((speci, i) => {
              return (
                <View key={i} style={styles.flex_container.self}>
                  <Text
                    key={speci.id}
                    style={{
                      ...styles.secondRow.right.addLine,
                      ...styles.flex_container.fit_content,
                      ...styles.flex_container.fit_content_first_item,
                      ...styles.curved_borders,
                      ...styles.tertiary,
                    }}
                  >
                    {speci.name}
                  </Text>
                  <Text key={"empty"} style={styles.flex_container.empty_item}></Text>
                </View>
              );
            })}
          </View>
        )}
        {item.work_branches.some((e) => e.id) && (
          <View style={styles.secondRow.right.block}>
            <Text style={styles.secondRow.right.block_title}>{translate('directory.member.info.label.branches')}</Text>
            {item.work_branches.map((branch, i) => {
              return (
                <View key={i} style={styles.flex_container.self}>
                  <Text
                    key={branch.id}
                    style={{
                      ...styles.secondRow.right.addLine,
                      ...styles.flex_container.fit_content,
                      ...styles.flex_container.fit_content_first_item,
                      ...styles.curved_borders,
                      ...styles.tertiary,
                    }}
                  >
                    {branch.name}
                  </Text>
                  <Text key={"empty"} style={styles.flex_container.empty_item}></Text>
                </View>
              );
            })}
          </View>
        )}
        {item.professional_groups.memberships.some((e) => e.id) > 0 && (
          <View style={styles.secondRow.right.block}>
            <Text style={styles.secondRow.right.block_title}>{translate('directory.member.info.label.beruf-group')}</Text>
            {item.professional_groups.memberships.map((mem, i) => {
              return (
                <View key={i} style={styles.flex_container.self}>
                  <Text
                    key={mem.id}
                    style={{
                      ...styles.secondRow.right.addLine,
                      ...styles.flex_container.fit_content,
                      ...styles.flex_container.fit_content_first_item,
                      ...styles.curved_borders,
                      ...styles.quinary,
                    }}
                  >
                    {mem.name}
                  </Text>
                  <Text key={"empty"} style={styles.flex_container.empty_item}></Text>
                </View>
              );
            })}
          </View>
        )}
        {item.sections.memberships.some((e) => e.id) > 0 && (
          <View style={styles.secondRow.right.block}>
            <Text style={styles.secondRow.right.block_title}>{translate('directory.member.info.label.section')}</Text>
            {item.sections.memberships.map((mem, i) => {
              return (
                <View key={i} style={styles.flex_container.self}>
                  <Text
                    key={mem.id}
                    style={{
                      ...styles.secondRow.right.addLine,
                      ...styles.flex_container.fit_content,
                      ...styles.flex_container.fit_content_first_item,
                      ...styles.curved_borders,
                      ...styles.quaternary,
                    }}
                  >
                    {mem.name}
                  </Text>
                  <Text key={"empty"} style={styles.flex_container.empty_item}></Text>
                </View>
              );
            })}
          </View>
        )}
      </View>
    </View>
  );
}
